import { Injectable } from '@angular/core';

import * as dayjs from 'dayjs';
import * as isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import * as isLeapYear from 'dayjs/plugin/isLeapYear';
import * as isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear); // dependency for isoWeeksInYear

@Injectable({
  providedIn: 'root',
})
export class IsoWeekService {
  isoWeeksInYear: number;
  isoWeek: number;
  isoYear: number;

  week: number;
  year: number;
  initialise() {
    const today = new Date();
    this.isoYear = today.getFullYear();
    this.isoWeek = dayjs().isoWeek();
    this.week = this.isoWeek;
    this.year = this.isoYear;
  }

  get currentWeek(): string {
    this.initialise();

    return `${this.year}-W${this.week.toString().padStart(2, '0')}`;
  }

  get previousWeek(): string {
    this.initialise();

    if (this.isoWeek === 1) {
      this.year = this.isoYear - 1;
      this.isoWeeksInYear = dayjs().year(this.year).isoWeeksInYear();
      this.week = this.isoWeeksInYear;
    } else {
      this.week--;
    }

    return `${this.year}-W${this.week.toString().padStart(2, '0')}`;
  }

  get nextWeek(): string {
    this.initialise();

    if (this.week === this.isoWeeksInYear) {
      this.week = 1;
      this.year = this.isoYear + 1;
    } else {
      this.week++;
    }

    return `${this.year}-W${this.week.toString().padStart(2, '0')}`;
  }
}
